import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Language } from '../models/language';
import { Observable, Subject } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Version } from '../modules/enviroment/version.model';
import { EnviromentSettings } from '../modules/enviroment/settings.model';

@Injectable({
  providedIn: 'root'
})

export class EnviromentService {
  language$:Observable<Language>;
  private languageSubject: Subject<Language>;
  private currentLanguage:Language;
  languageKey: string = "currentLanguage";

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,  
    private http: HttpClient,  
    @Inject('BASE_URL') private rootUrl: string
  ) { 
    this.languageSubject = new Subject<Language>();
    this.language$ = this.languageSubject.asObservable();
  }
  storeLocal(key: string, value: string) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(key, value);
    }
  }
  getLocal(key: string): string {
    const ret = localStorage.getItem(key);

    return ret;
  }
  isLocal(key: string): boolean {
    const ret = localStorage.getItem(key);

    return ret?true:false;
  }
  setLanguage(language:Language | null){
    this.currentLanguage = language;
    if (isPlatformBrowser(this.platformId)) {
      if (language) {
        localStorage.setItem(
          this.languageKey,
          JSON.stringify(language));
      }
      else {
        localStorage.removeItem(this.languageKey);
      }
    }    
  }
   getLanguage():Language | null {
    if (isPlatformBrowser(this.platformId)) {
      var i = localStorage.getItem(this.languageKey);
      if (i) {
        return <Language>JSON.parse(i);
      }
    }
    return null;
  }
  getVersion(): Observable<Version> {
    return this.http.get<Version>(`${this.rootUrl}/enviroment/version`);
  }
  getSettings(autoLogin:string = ''): Observable<EnviromentSettings> {
    let params = {};
    params['autoLogin'] = autoLogin;
    return this.http.get<EnviromentSettings>(`${this.rootUrl}/enviroment/settings`, {params: params});
  }
  getCustomerSettings(): Observable<Object> {

    return this.http.get<Object>(`${this.rootUrl}/enviroment/settings/customer`);
  }
}
